/******************** Custom JS for Boost AI Search & Discovery ********************/

(function () {
  function formatNumber(value) {
    const number = Number(String(value).replace(/,/g, ''));

    if (Number.isNaN(number)) {
      return value;
    }

    return number.toLocaleString('ja-JP');
  }

  function formatPriceDisplay() {
    /* スライダー下の目盛り */
    document
      .querySelectorAll('.boost-pfs-filter-option-range-slider .noUi-value')
      .forEach(function (element) {
        const currentText = element.textContent.trim();
        const formattedText = formatNumber(currentText);

        if (currentText !== formattedText) {
          element.textContent = formattedText;
        }
      });

    /* 緑色の最小・最大価格欄 */
    document
      .querySelectorAll(
        '.boost-pfs-filter-option-range-amount-min, .boost-pfs-filter-option-range-amount-max'
      )
      .forEach(function (input) {
        const formattedValue = formatNumber(input.value);

        if (input.value !== formattedValue) {
          input.value = formattedValue;
        }
      });

    /* 選択結果の価格表示：¥6075 - ¥16230 → ¥6,075 - ¥16,230 */
    document
      .querySelectorAll('.boost-pfs-filter-selected-items-mobile')
      .forEach(function (element) {
        const currentText = element.textContent;

        const formattedText = currentText.replace(
          /¥\s*([\d,]+)/g,
          function (_, value) {
            const number = Number(value.replace(/,/g, ''));

            return Number.isNaN(number)
              ? '¥' + value
              : '¥' + number.toLocaleString('ja-JP');
          }
        );

    if (currentText !== formattedText) {
      element.textContent = formattedText;
    }
  });
  }

  function attachSliderEvents() {
    document
      .querySelectorAll(
        '.boost-pfs-filter-option-range-slider.noUi-target, ' +
        '.boost-pfs-filter-option-range-slider .noUi-target'
      )
      .forEach(function (slider) {
        if (!slider.noUiSlider || slider.dataset.commaFormatAttached === 'true') {
          return;
        }

        slider.dataset.commaFormatAttached = 'true';

        slider.noUiSlider.on('update', function () {
          /* Boostが数値を書き換えた直後にカンマを付け直す */
          setTimeout(formatPriceDisplay, 0);
        });

        slider.noUiSlider.on('slide', function () {
          setTimeout(formatPriceDisplay, 0);
        });

        slider.noUiSlider.on('set', function () {
          setTimeout(formatPriceDisplay, 0);
        });
      });
  }

  function refreshPriceFormat() {
    formatPriceDisplay();
    attachSliderEvents();
    removeSortByLabel();
  }

  function initPriceFormat() {
    refreshPriceFormat();

    const observer = new MutationObserver(function () {
      refreshPriceFormat();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceFormat);
  } else {
    initPriceFormat();
  }
})();

/* SORT BY: のラベルを消す */
function removeSortByLabel() {
  document
    .querySelectorAll('.boost-pfs-filter-top-sorting label')
    .forEach(function (label) {
      label.remove();
    });
}

/* Boost AI Search & Filter：フィルター項目名を入力どおりに補正 */
document.addEventListener('DOMContentLoaded', function () {
  function fixBoostFilterText() {
    document.querySelectorAll('.boost-pfs-filter-option-value').forEach(function (item) {
      if (item.textContent.indexOf('Ittoの糸見本') !== -1) {
        item.textContent = item.textContent.replace('Ittoの糸見本', 'ittoの糸見本');
      }
    });
  }

  fixBoostFilterText();

  setInterval(fixBoostFilterText, 1000);
});